import { render, staticRenderFns } from "./payBtn.vue?vue&type=template&id=21d65cf9&scoped=true&"
import script from "./payBtn.vue?vue&type=script&lang=js&"
export * from "./payBtn.vue?vue&type=script&lang=js&"
import style0 from "./payBtn.vue?vue&type=style&index=0&id=21d65cf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d65cf9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d65cf9')) {
      api.createRecord('21d65cf9', component.options)
    } else {
      api.reload('21d65cf9', component.options)
    }
    module.hot.accept("./payBtn.vue?vue&type=template&id=21d65cf9&scoped=true&", function () {
      api.rerender('21d65cf9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/insurance/payBtn.vue"
export default component.exports